import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, CircularProgress, Typography } from '@mui/material';

import { useAuth } from './AuthContext';

interface SmartRedirectProps {
  targetPath?: string;
  regPlate?: string;
}

const SmartRedirect: React.FC<SmartRedirectProps> = ({ targetPath: propTargetPath, regPlate: propRegPlate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, isInitializing } = useAuth();

  // Lire les paramètres depuis l'URL si pas fournis en props
  const urlParams = new URLSearchParams(location.search);
  const targetPath = propTargetPath || urlParams.get('target') || '/';
  const regPlate = propRegPlate || urlParams.get('regPlate') || undefined;
  const action = urlParams.get('action') || undefined;

  useEffect(() => {
    const handleRedirect = () => {
      // Construire l'URL cible avec les paramètres
      let finalTargetPath = targetPath;
      const params = new URLSearchParams();

      if (regPlate) {
        params.append('autoSearch', regPlate);
      }

      if (action) {
        params.append('action', action);
      }

      if (params.toString()) {
        finalTargetPath += `?${params.toString()}`;
      }

      console.log('SmartRedirect - État actuel:', {
        currentUser: !!currentUser,
        isInitializing,
        targetPath,
        regPlate,
        finalTargetPath,
      });

      // Si l'utilisateur est connecté, aller directement à la destination
      if (currentUser && !isInitializing) {
        console.log('SmartRedirect - Utilisateur connecté, redirection directe vers:', finalTargetPath);
        navigate(finalTargetPath, { replace: true });
        return;
      }

      // Si l'utilisateur n'est pas connecté, rediriger vers login avec la destination
      if (!isInitializing) {
        console.log(
          'SmartRedirect - Utilisateur non connecté, redirection vers login avec destination:',
          finalTargetPath,
        );
        navigate('/login', {
          state: { from: finalTargetPath },
          replace: true,
        });
      }
    };

    // Attendre que l'initialisation soit terminée
    if (!isInitializing) {
      handleRedirect();
    }
  }, [currentUser, isInitializing, navigate, targetPath, regPlate]);

  // Afficher un loader pendant l'initialisation
  if (isInitializing) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Vérification de votre connexion...
        </Typography>
      </Box>
    );
  }

  return null;
};

export default SmartRedirect;
